import useReceipts from '@/utils/hooks/swr/pricing/useReceipts';
import useSubscription from '@/utils/hooks/swr/pricing/useSubscription';

import { ErrorPage } from '@/components/pages/settings/subscription-invoices/PageContent/ErrorPage';
import { NoSubscription } from '@/components/pages/settings/subscription-invoices/PageContent/NoSubscription';
//Components
import { PageLoading } from '@/components/pages/settings/subscription-invoices/PageContent/PageLoading';
import { SubscriptionPage } from '@/components/pages/settings/subscription-invoices/PageContent/SubscriptionPage';

type ContentProps = {
    togglePlanModal: () => void;
};
export function Content({ togglePlanModal }: ContentProps) {
    const { subscription, isLoading, subscriptionError } = useSubscription();
    const { isLoadingInitialData: isLoadingReceipts } = useReceipts();

    if (isLoading || isLoadingReceipts) {
        return <PageLoading />;
    }
    if (subscriptionError) {
        return <ErrorPage />;
    }

    if (!subscription.product_key) {
        return <NoSubscription subscription={subscription} togglePlanModal={togglePlanModal} />;
    }

    return <SubscriptionPage togglePlanModal={togglePlanModal} />;
}
